var _defs, _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "user",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6",
    "data-name": "Rect\\xE1ngulo 6",
    width: 16.377,
    height: 20.373,
    transform: "translate(0 0)",
    fill: "none"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_32",
    "data-name": "Rect\\xE1ngulo 32",
    width: 24,
    height: 24,
    fill: "white",
    opacity: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11",
    "data-name": "Grupo 11",
    transform: "translate(4 2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_10",
    "data-name": "Grupo 10",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8",
    "data-name": "Trazado 8",
    d: "M8.189,9.348C3.673,9.348,0,12.689,0,16.8v.827a2.753,2.753,0,0,0,2.75,2.75H13.627a2.753,2.753,0,0,0,2.75-2.75V16.8c0-4.107-3.673-7.448-8.188-7.448M14.877,16.8v.827a1.251,1.251,0,0,1-1.25,1.25H2.75a1.251,1.251,0,0,1-1.25-1.25V16.8c0-3.28,3-5.948,6.689-5.948s6.688,2.668,6.688,5.948",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9",
    "data-name": "Trazado 9",
    d: "M8.189,8.347A4.174,4.174,0,1,0,4.015,4.173,4.179,4.179,0,0,0,8.189,8.347M5.515,4.173A2.674,2.674,0,1,1,8.189,6.847,2.676,2.676,0,0,1,5.515,4.173",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserWhite);
export default __webpack_public_path__ + "static/media/userWhite.668e20be3f915bd6d358519b3486f5de.svg";
export { ForwardRef as ReactComponent };